import { render, staticRenderFns } from "./AddContactDialog.vue?vue&type=template&id=335415ba&scoped=true"
import script from "./AddContactDialog.vue?vue&type=script&lang=ts"
export * from "./AddContactDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335415ba",
  null
  
)

export default component.exports